"use client";

import React, { useRef, useState, useEffect } from "react";

import Image from "next/image";
import CornerChip from "@/components/global/ui/CornerChip";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTACornerButton } from "@/shadcn/ui/corner-button";
import {
  HLSVideoPlayer,
  SanityVideoPlayer,
} from "@/components/ui/SanityVideoPlayer";
import { Dialog, DialogContent } from "@/shadcn/ui/dialog";

import { PageAboutSchema } from "@/sanity/pages/PageAboutTemplate";

import volumeMute from "@/public/icons/Volume--mute--filled.svg";
import volumeUnmute from "@/public/icons/Volume--up--filled.svg";
import maximize from "@/public/icons/Maximize.svg";
import screenEffect from "@/public/about/screen-effect.svg";
import { PageInnerCircleSchema } from "@/sanity/pages/PageInnerCircleTemplate";
import Chip from "../global/ui/Chip";
import Divider from "../global/ui/Divider";
import DividerGreenLine from "../global/ui/DividerGreenLine";
import ChipScrollingBanner from "../global/ui/ChipScrollingBanner";
import GridNoise from "../global/ui/GridNoise";
import CardGrid from "./CardGrid";
import TimedCards from "../global/ui/TimedCards";

export default function MembershipSection({
  data,
  className,
}: {
  data: PageInnerCircleSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative flex pb-[11rem] lg:pb-[9rem] px-[2rem] lg:px-0 bg-white",
        className,
      )}
    >
      <div className="relative flex flex-col items-center w-full">
        {data?.membershipTitle && (
          <div className="richtext richtext-center prose-headings:not-italic prose-headings:text-black prose-headings:text-[6rem] lg:prose-headings:text-[7rem] prose-headings:font-ivy prose-p:text-white/60 mb-[4rem] lg:mb-[5rem]">
            <PortableText
              value={data.membershipTitle}
              components={richTextComponent}
            />
          </div>
        )}

        {data.membershipCards && (
          <TimedCards
            cards={data.membershipCards}
            timePerCard={10}
            className="w-[min(183rem,100%)]"
          />
        )}

        {/*<div className="w-[min(183rem,100%)] bg-[#112628] mt-[4rem] lg:mt-[7rem] p-[3rem] lg:pl-[4rem] lg:py-[2.81rem] lg:pr-[1rem] flex flex-col lg:flex-row gap-[2rem] justify-between items-center">
          <div className="richtext richtext-center lg:richtext-start prose-p:text-white prose-p:text-[2.25rem] prose-p:font-light prose-p:leading-[150%]">
            <PortableText
              value={data.membershipCtaText}
              components={richTextComponent}
            />
          </div>
          {data.membershipCTA && (
            <div className="w-[40rem]">
              <CTACornerButton data={data.membershipCTA} />
            </div>
          )}
        </div>*/}

        {data.membershipCTA && (
          <div className="w-[40rem] mt-[2rem]">
            <CTACornerButton data={data.membershipCTA} />
          </div>
        )}
      </div>
    </section>
  );
}
